'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _user = require('../../redux/modules/user');

var _config = require('../../redux/modules/config');

var _browser = require('../../redux/modules/browser');

var _whiteLabel = require('../../redux/modules/whiteLabel');

var _modal = require('../../redux/modules/modal');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AppHeaderMeta = require('./AppHeaderMeta');

var _AppHeaderMeta2 = _interopRequireDefault(_AppHeaderMeta);

var _reduxAsyncConnect = require('@liveauctioneers/redux-async-connect');

var _Auth = require('./Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _BannerOutdatedBrowser = require('../../components/BannerOutdatedBrowser/BannerOutdatedBrowser');

var _BannerOutdatedBrowser2 = _interopRequireDefault(_BannerOutdatedBrowser);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _Footer = require('../../components/Footer/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _windowSize = require('../../redux/modules/windowSize');

var _Header = require('../../components/Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Modals = require('../../components/Modals/Modals');

var _Modals2 = _interopRequireDefault(_Modals);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analytics = require('../../redux/modules/analytics');

var _SailthruInit = require('../../components/Sailthru/SailthruInit');

var _SailthruInit2 = _interopRequireDefault(_SailthruInit);

var _reactRouterScroll = require('react-router-scroll');

var _SegmentTracker = require('../../components/Segment/SegmentTracker');

var _SegmentTracker2 = _interopRequireDefault(_SegmentTracker);

var _Sentry = require('../../components/Sentry/Sentry');

var _Sentry2 = _interopRequireDefault(_Sentry);

var _SoastaGlobalSetter = require('../../components/Soasta/SoastaGlobalSetter');

var _SoastaGlobalSetter2 = _interopRequireDefault(_SoastaGlobalSetter);

var _App = require('./App.scss');

var _App2 = _interopRequireDefault(_App);

var _login = require('../../redux/modules/login');

var _WindowSizeContainer = require('../../components/WindowSizeContainer/WindowSizeContainer');

var _WindowSizeContainer2 = _interopRequireDefault(_WindowSizeContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    deferred: true,
    promise: function promise(options) {
        var store = options.store;
        var dispatch = store.dispatch,
            getState = store.getState;

        var authToken = (0, _user.getAuthToken)(getState());
        return dispatch((0, _user.fetchBidderDataIfNeeded)(authToken));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
    var authToken = (0, _user.getAuthToken)(state);
    var baseUrl = (0, _config.getBaseUrl)(state);
    var bidderIsLoaded = (0, _user.isBidderLoaded)(state);
    var browser = (0, _browser.getUiBrowser)(state);
    var classicBaseUrl = (0, _config.getClassicBaseUrl)(state);
    var mainhostLogin = (0, _user.getMainhostLogin)(state);
    var mobile = (0, _browser.isUiMobile)(state);
    var sailthruCustomerId = (0, _config.getSailthruCustomerId)(state);
    var userData = (0, _user.getUserData)(state);
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    var logo = (0, _whiteLabel.getWhiteLabelLogo)(state);
    var biddingConsole = ownProps.location.pathname.includes('/console/');

    var _getWindowSize = (0, _windowSize.getWindowSize)(state),
        windowWidth = _getWindowSize.width;

    return {
        authToken: authToken,
        baseUrl: baseUrl,
        bidderIsLoaded: bidderIsLoaded,
        biddingConsole: biddingConsole,
        browser: browser,
        classicBaseUrl: classicBaseUrl,
        logo: logo,
        mainhostLogin: mainhostLogin,
        mobile: mobile,
        sailthruCustomerId: sailthruCustomerId,
        userData: userData,
        userLoggedIn: userLoggedIn,
        whiteLabel: whiteLabel,
        windowWidth: windowWidth
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        fetchBidderDataIfNeeded: _user.fetchBidderDataIfNeeded,
        logOutBidder: _user.logOutBidder,
        openCreateAccountModal: _modal.openCreateAccountModal,
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openHealthcheckModal: _modal.openHealthcheckModal,
        openLoginModal: _modal.openLoginModal,
        recordAnalyticsForIdentify: _analytics.recordAnalyticsForIdentify,
        submitLogin: _login.submitLogin
    }, dispatch);
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(App, _Component);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref, [this].concat(args))), _this), _this.getRequiredData = function () {
            var _this$props = _this.props,
                authToken = _this$props.authToken,
                bidderIsLoaded = _this$props.bidderIsLoaded,
                mainhostLogin = _this$props.mainhostLogin;


            if (!bidderIsLoaded) {
                if (!authToken && mainhostLogin.authVerify) {
                    _this.props.submitLogin(null, null, mainhostLogin);
                } else if (authToken) {
                    _this.props.fetchBidderDataIfNeeded(authToken);
                }
            }
        }, _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
            // if coming back from an external page, the prevRouterProps will be null
            if (!prevRouterProps) return [0, 0];
            if (prevRouterProps.location.query.page !== routerProps.location.query.page) return true;
            if (prevRouterProps.location.query.parameters !== routerProps.location.query.parameters) return true;
            return prevRouterProps.location.pathname !== routerProps.location.pathname;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (window.optimizelyHook) {
                window.optimizelyHook();
            }

            if (!__DEVELOPMENT__) {
                var addThis = document.createElement('script');
                addThis.src = '//s7.addthis.com/js/300/addthis_widget.js#pubid=liveauctioneers';
                addThis.type = 'text/javascript';
                addThis.async = true;

                var intlPolyfill = document.createElement('script');
                intlPolyfill.src = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl.~locale.en';
                intlPolyfill.type = 'text/javascript';
                intlPolyfill.async = true;

                document.head.appendChild(intlPolyfill);
                document.head.appendChild(addThis);
            }

            this.getRequiredData();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (typeof window !== 'undefined' && window.optimizelyHook) {
                window.optimizelyHook();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                authToken = _props.authToken,
                baseUrl = _props.baseUrl,
                biddingConsole = _props.biddingConsole,
                browser = _props.browser,
                children = _props.children,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location,
                logo = _props.logo,
                mainhostLogin = _props.mainhostLogin,
                mobile = _props.mobile,
                sailthruCustomerId = _props.sailthruCustomerId,
                userData = _props.userData,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;


            return (0, _jsx3.default)(_reactRouterScroll.ScrollContainer, {
                scrollKey: 'app',
                shouldUpdateScroll: this.shouldUpdateScroll
            }, void 0, (0, _jsx3.default)('div', {
                className: _App2.default.app
            }, void 0, (0, _jsx3.default)(_WindowSizeContainer2.default, {}), (0, _jsx3.default)(_Sentry2.default, {}), (0, _jsx3.default)(_AppHeaderMeta2.default, {
                baseUrl: baseUrl,
                pathname: location.pathname
            }), (0, _jsx3.default)(_SailthruInit2.default, {
                customerId: sailthruCustomerId
            }), (0, _jsx3.default)(_Auth2.default, {
                authToken: authToken,
                mainhostLogin: mainhostLogin,
                recordAnalyticsForIdentify: this.props.recordAnalyticsForIdentify,
                userData: userData,
                userLoggedIn: userLoggedIn
            }), !!browser.isOutdated && (0, _jsx3.default)(_BannerOutdatedBrowser2.default, {
                name: browser.name,
                majorVersion: browser.majorVersion
            }), !biddingConsole && (0, _jsx3.default)(_Header2.default, {
                baseUrl: baseUrl,
                biddingConsole: biddingConsole,
                classicBaseUrl: classicBaseUrl,
                location: location,
                logo: logo,
                logOutBidder: this.props.logOutBidder,
                mobile: mobile,
                openCreateAccountModal: this.props.openCreateAccountModal,
                openLoginModal: this.props.openLoginModal,
                userLoggedIn: userLoggedIn,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }), (0, _jsx3.default)('div', {
                className: _App2.default.appContent,
                id: 'main'
            }, void 0, children), !biddingConsole && (0, _jsx3.default)(_Footer2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                openDownloadMobileModal: this.props.openDownloadMobileModal,
                openHealthcheckModal: this.props.openHealthcheckModal,
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)(_Modals2.default, {}), (0, _jsx3.default)(_SegmentTracker2.default, {}), (0, _jsx3.default)(_SoastaGlobalSetter2.default, {})));
        }
    }]);
    return App;
}(_react.Component), _class2.defaultProps = {
    authToken: _propTypes2.default.string,
    userLoggedIn: false
}, _temp2)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/App.js
// module id = TJgB
// module chunks = 46